export default "__VITE_ASSET__DNIV1x3P__"